import { AssemblyDisapprovalType } from "../../../enums/AssemblyDisapprovalType";

export class RegisterAssemblyDisapprovalByOrderInput {
  orderId: number;
  createdById: number;
  problemType: AssemblyDisapprovalType;
  problemDetails: string;
}